import { useCallback } from "react";
import { VariaveisAmbiente } from "../../../../config";
import { ETypeDomain } from "../../../../config/types";
import { RelatorioBalancoMedicamentoModel } from "../../../../views/pages/private/relatorios/models/relatorio-models";
import { useApiBase } from "../../base/api-base";

export function useGerarRelatorioBMPO() {
  const { invocarApi, carregando, ...outrasPropriedades } = useApiBase();

  const gerarRelatorioBMPO = useCallback(
    (filtros: RelatorioBalancoMedicamentoModel) => {
      return invocarApi({
        url: `Relatorio/relatorio-bmpo`,
        method: "POST",
        enviarTokenUsuario: true,
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(filtros),
        baseURL: VariaveisAmbiente.apiUrl,
        typeDomain: ETypeDomain.TouchPharma,
        apiVersion: 'v1'
      });
    },
    [invocarApi]
  );
  return {
    ...outrasPropriedades,
    carregando,
    gerarRelatorioBMPO,
  };

}